import script from "./ProductMpPreviewDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductMpPreviewDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProductMpPreviewDrawer.vue?vue&type=style&index=0&id=bc6efbb2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc6efbb2"]])

export default __exports__